import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M4 21.067h3.067c.533 0 .933-.134 1.2-.534s.533-.8.533-1.2v-7.2c0-.533-.133-.933-.533-1.2-.267-.4-.667-.666-1.2-.666H4M28 10.4h-3.067c-.533 0-.933.133-1.2.533s-.533.8-.533 1.2V19.2c0 .533.133.933.533 1.2s.8.533 1.2.533H28"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M23.2 19.467H22c-.4 0-.8.133-1.067.266l-5.6 2.534M14.133 11.6c-.666-.4-1.466-.533-2.133-.267L8.933 12.4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "m23.333 11.2-3.866-1.733c-.8-.267-1.734-.134-2.534.266L13.467 12c-.934.667-1.2 1.867-.534 2.8l.4.4c.534.533 1.467.667 2.134.267l2.133-.934"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#0000E7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "m17.467 14.533 1.066.934c1.067.933 1.2 2.666.134 3.733l-.134.133-2.666 2.4c-1.067.934-2.534.934-3.6 0L10.4 20c-.4-.4-.933-.667-1.6-.667"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }